
export const INGREDIENT_FAMILIES = {
    'soğan': {
        default: 'Soğan',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Kuru soğan', 'Kırmızı soğan', 'Arpacık soğan', 'Taze soğan']
    },
    'domates': {
        default: 'Domates',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Çeri domates', 'Pembe domates', 'Salkım domates']
    },
    'salatalık': {
        default: 'Salatalık',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Çengelköy Salatalık', 'Kornişon']
    },
    'biber': {
        default: 'Biber',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Sivri Biber', 'Çarliston Biber', 'Kapya Biber', 'Dolmalık Biber', 'Köy biberi']
    },
    'patlıcan': {
        default: 'Patlıcan',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Kemer Patlıcan', 'Topan Patlıcan']
    },
    'kabak': {
        default: 'Kabak',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Sakız Kabak', 'Bal kabağı', 'Girit kabağı']
    },
    'lahana': {
        default: 'Lahana',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Beyaz Lahana', 'Mor Lahana', 'Brüksel Lahanası']
    },
    'mantar': {
        default: 'Mantar',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Kültür Mantarı', 'İstiridye Mantarı', 'Kestane Mantarı']
    },
    'marul': {
        default: 'Marul',
        market_unit: 'adet',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 300, // 1 adet = 300g
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Kıvırcık Marul', 'Göbek Marul', 'Iceberg Marul']
    },
    'sarımsak': {
        default: 'Sarımsak',
        market_unit: 'baş',
        storage_unit: 'g',
        recipe_unit: 'diş',
        multiplier: 50, // 1 baş = 50g
        recipe_to_storage_multiplier: 3, // 1 diş = 3g
        isVariableWeight: false,
        requiresBrand: false
    },
    'havuç': {
        default: 'Havuç',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false
    },
    'patates': {
        default: 'Patates',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false
    },
    'elma': {
        default: 'Elma',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Kırmızı Elma', 'Yeşil Elma', 'Golden Elma', 'Amasya Elması']
    },
    'armut': {
        default: 'Armut',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Deveci Armut', 'Santa Maria Armut', 'Ankara Armudu']
    },
    'üzüm': {
        default: 'Üzüm',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Çekirdeksiz Üzüm', 'Siyah Üzüm', 'Yeşil Üzüm']
    },
    'şeftali': {
        default: 'Şeftali',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Tüysüz Şeftali', 'Nektarin']
    },
    'erik': {
        default: 'Erik',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Yeşil Erik', 'Kırmızı Erik', 'Siyah Erik']
    },
    'peynir': {
        default: 'Peynir',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: true,
        requiresBrand: true,
        variants: ['Beyaz peynir', 'Kaşar Peyniri', 'Tulum Peyniri', 'Lor Peyniri', 'Labne', 'Krem peynir', 'Dil peyniri', 'Örgü peyniri', 'Hellim', 'Mozzarella', 'Cheddar']
    },
    'yoğurt': {
        default: 'Yoğurt',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 2000,
        isVariableWeight: true,
        requiresBrand: true,
        variants: ['Tam Yağlı Yoğurt', 'Yarım Yağlı Yoğurt', 'Süzme Yoğurt']
    },
    'süt': {
        default: 'Süt',
        market_unit: 'lt',
        storage_unit: 'ml',
        recipe_unit: 'ml',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Tam Yağlı Süt', 'Yarım Yağlı Süt', 'Laktozsuz Süt']
    },
    'pirinç': {
        default: 'Pirinç',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Baldo Pirinç', 'Osmancık Pirinç', 'Basmati Pirinç', 'Jasmine Pirinç']
    },
    'bulgur': {
        default: 'Bulgur',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Pilavlık Bulgur', 'İnce Bulgur', 'Köftelik Bulgur', 'Siyez Bulguru']
    },
    'un': {
        default: 'Un',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Beyaz Un', 'Tam buğday unu', 'Mısır unu', 'Siyez unu', 'Çavdar unu']
    },
    'makarna': {
        default: 'Makarna',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 500,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Spagetti', 'Fiyonk Makarna', 'Burgu Makarna', 'Kalem Makarna']
    },
    'şehriye': {
        default: 'Şehriye',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 500,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Arpa Şehriye', 'Tel Şehriye']
    },
    'zeytin': {
        default: 'Zeytin',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 500,
        isVariableWeight: true,
        requiresBrand: true,
        variants: ['Siyah Zeytin', 'Yeşil Zeytin', 'Sele Zeytin', 'Salamura Zeytin']
    },
    'fasulye': {
        default: 'Fasulye',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Taze fasulye', 'Dermason Fasulye', 'Şeker Fasulye', 'Barbunya', 'Börülce']
    },
    'mercimek': {
        default: 'Mercimek',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Kırmızı Mercimek', 'Yeşil Mercimek', 'Sarı Mercimek']
    },
    'et': {
        default: 'Et',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: true,
        requiresBrand: false,
        variants: ['Dana Kıyma', 'Dana Kuşbaşı', 'Dana Biftek', 'Dana Antrikot', 'Dana Rosto', 'Kuzu Pirzola', 'Kuzu Kuşbaşı', 'Kuzu İncik']
    },
    'tavuk': {
        default: 'Tavuk',
        market_unit: 'kg',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 1000,
        isVariableWeight: true,
        requiresBrand: false,
        variants: ['Tavuk Göğüs', 'Tavuk But', 'Tavuk Kanat', 'Tavuk Bütün']
    },
    'balık': {
        default: 'Balık',
        market_unit: 'adet',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 400,
        isVariableWeight: true,
        requiresBrand: false,
        variants: ['Levrek', 'Hamsi', 'İstavrit', 'Sardalya', 'Somon', 'Çipura', 'Palamut', 'Uskumru', 'Mezgit', 'Alabalık']
    },
    'ekmek': {
        default: 'Ekmek',
        market_unit: 'adet',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 240,
        isVariableWeight: true,
        requiresBrand: false,
        variants: ['Beyaz Ekmek', 'Tam Buğday Ekmek', 'Çavdar Ekmeği']
    },
    'yufka': {
        default: 'Yufka',
        market_unit: 'adet',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 150,
        isVariableWeight: true,
        requiresBrand: false,
        variants: ['Günlük Yufka', 'Lavaş', 'Bazlama', 'Tortilla']
    },
    'yağ': {
        default: 'Sıvı Yağ',
        market_unit: 'lt',
        storage_unit: 'ml',
        recipe_unit: 'ml',
        multiplier: 1000,
        isVariableWeight: false,
        requiresBrand: true,
        variants: ['Ayçiçek yağı', 'Mısır yağı', 'Kanola yağı', 'Sıvı yağ', 'Zeytinyağı']
    },
    'kabartma tozu': {
        default: 'Kabartma Tozu',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 10, // 1 paket = 10g
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Hamur kabartma tozu']
    },
    'vanilya': {
        default: 'Vanilya',
        market_unit: 'paket',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 5, // 1 paket = 5g
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Şekerli vanilin']
    },
    'dereotu': {
        default: 'Dereotu',
        market_unit: 'demet',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 50, // 1 demet = ~50g
        isVariableWeight: false,
        requiresBrand: false
    },
    'maydanoz': {
        default: 'Maydanoz',
        market_unit: 'demet',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 60, // 1 demet = ~60g
        isVariableWeight: false,
        requiresBrand: false
    },
    'nane': {
        default: 'Nane',
        market_unit: 'demet',
        storage_unit: 'g',
        recipe_unit: 'g',
        multiplier: 30, // 1 demet = ~30g
        isVariableWeight: false,
        requiresBrand: false,
        variants: ['Taze nane', 'Kuru nane']
    }
};

export const getIngredientFamily = (name) => {
    if (!name) return null;
    const lower = name.toLowerCase().trim();
    // Normalize input to handle Turkish characters in lookup if needed
    // But since the keys are Turkish, a simple case match usually works
    // For robust matching, we use the loop in unitUtils.js
    return INGREDIENT_FAMILIES[lower] || null;
};
